
import { KindCount } from "../enums/kind-count";
import { Parameter } from "../models/form-model/models/form-controlls.model";
import { countClass, Tabela, Wiersz } from "./countClass";
import { Component, ComponentScript, FunctionDef, FunctionScript, MaterialsData, Parametr } from "./parts";

export class  Technologia {
 // podstawowe informacje
  techMS: number;
  ScriptKind: number;
  NameWithPrefix: string;
  Nazwa: string;

  ContractorNumber?: string;
  ElapsedTime?: number;
  ExceptionMessage?: string;

  // dane techniczne
  CalculationsData?: string[];
  MaterialsData?: MaterialsData;
  Calculations: countClass[];

  // parametry
  ParametryWejsciowe: Parametr[];
  ParametryWylicz: Parametr[];
  ParametryAktualne: Parametr[];
  ParametryPrevAktualne: Parametr[];

  // skrypty i komponenty
  Components: Component[];
  ComponentScripts: ComponentScript[];
  Functions: FunctionDef[];
  FunctionScripts?: FunctionScript[];

  // inne
  ExtendedParameterDT?: any[];


  Sections?: Record<string, string>;
  constructor(public data){
    this.techMS = data.techMS;
    this.ScriptKind = data.ScriptKind;
    this.NameWithPrefix = data.NameWithPrefix;
    this.Nazwa = data.Nazwa;
    this.ContractorNumber = data.ContractorNumber;
    this.ElapsedTime = data.ElapsedTime;
    this.ExceptionMessage = data.ExceptionMessage;
    this.CalculationsData = data.CalculationsData;
    this.MaterialsData = data.MaterialsData;
    this.ParametryWejsciowe = data.ParametryWejsciowe;
    this.ParametryWylicz = data.ParametryWylicz;
    this.Components = data.Components;
    this.ComponentScripts = data.ComponentScripts;
    this.Functions = data.Functions;
    this.FunctionScripts = data.FunctionScripts;
    this.ExtendedParameterDT= data.ExtendedParameterDT;
    this.Sections = data.Sections; 
    this.Init();
  }
  public Init(){
    // this.ZerujParametry();
    this.Functions.forEach(f => {
      f.ParametryAktualne = [];
      f.CalculationsData = [];
      //f.Body.replace(/^.*?\(/, '').replace(/\#\#$/, '');
        var lines = f.Body.split("\r\n");
        var czyWylicz = false;
            // console.info("wylicz2", lines);
        lines.forEach(linia => {
          if(linia.includes("##Parametry")){
            czyWylicz = false;
          } else if(linia.includes("##Wylicz")){
            czyWylicz = true;
            // console.info("wylicz", linia);
          } else if(linia.includes("##")){
          } else if(linia.trim() == ""){
          } else if(!czyWylicz){
            
            var p = new Parametr();
            p.Nazwa = linia.replace(/\s.*$/, '');
            var war = linia.replace(/^.*?\[/, '').replace(/\]$/, '').split(",");
            if(war.length > 0 && war[0].trim()!= "*"){
              p.Wartosc = war[0];
            }
            f.ParametryAktualne.push(p);
            // console.info("war", linia, p);
          } else {
            if(linia.trim().startsWith("[")){
              f.CalculationsData[f.CalculationsData.length - 1]+="\r\n"+linia;
            } else {
              f.CalculationsData.push(linia);
            }
          }
        });
        this.InitWylicz(f);
    });
    this.InitWylicz(this);
  }
  public ZerujParametry(){
    this.ParametryAktualne = [];
    this.ParametryWejsciowe.forEach(element => {
      var x = new Parametr();
      x.Nazwa = element.Nazwa;
      x.Wartosc = element.Wartosc;
      this.ParametryAktualne.push(x);
    });
    this.ParametryPrevAktualne = [];
    this.ParametryWejsciowe.forEach(element => {
      var x = new Parametr();
      x.Nazwa = element.Nazwa;
      x.Wartosc = element.Wartosc;
      this.ParametryPrevAktualne.push(x);
    });

  }
  
  public UstawParamInit(par:Parameter[], prev_par:Parameter[]){
  
     const start = performance.now();
    // console.info("par", par);
    this.ZerujParametry();
    par.forEach(element => {
      var j = this.ParametryAktualne.find(x=> "&"+element.Key == x.Nazwa)
      if(j != null){
        j.Wartosc = element.Value;
      } else {
        var x = new Parametr();
        x.Nazwa = "&"+element.Key;
        x.Wartosc = element.Value;
        this.ParametryAktualne.push(x);
      }
    });
    
    prev_par.forEach(element => {
      var j = this.ParametryPrevAktualne.find(x=> "&"+element.Key == x.Nazwa)
      if(j != null){
        j.Wartosc = element.Value;
      } else {
        var x = new Parametr();
        x.Nazwa = "&"+element.Key;
        x.Wartosc = element.Value;
        this.ParametryPrevAktualne.push(x);
      }
    });
    this.Wylicz(this.Calculations, this.ParametryAktualne);
    
    const end = performance.now();
    console.info("wynik", this.ParametryAktualne);
    console.info(`Czas wykonania: ${(end - start).toFixed(2)} ms`);

  }

  public Wylicz(Calculations:countClass[], ParametryAktualne: Parametr[]){
    // console.info("wylicz", Calculations);
    Calculations.forEach(c => {
      this.Przelicz(c, ParametryAktualne);
    });
    var result = ParametryAktualne.find(x=> x.Nazwa == "&return"); 
      if(result != null){
        // console.info("Funkcja zwróciła", result);
        return result.Wartosc;
      } else {
         console.info("Funkcja zwróciła", "X");
        return "X";
      }
  }
  
  public parseKindCount(value: string): KindCount | null {
    if (value in KindCount) {
      return KindCount[value as keyof typeof KindCount];
    }
    return null;
  }

  public Przelicz(c:countClass, ParametryAktualne:Parametr[]){
    // console.info("przelicz", c);
var wartosc = ParametryAktualne.find(x => x.Nazwa == c.ParamDoZmiany);

/*
      if(c.typ == KindCount.TabelaSpecjanla){
        c.typ = this.parseKindCount(c.daneTabeli.zakresy.wartosci[0]);
        if(!c.daneTabeli.ZmianaTabelaSpecjanla) {
          c.daneTabeli.ZmianaTabelaSpecjanla = true;
          console.info("nie było tabeli ", c.ParamDoZmiany );
          if(c.daneTabeli.zakresy.wartosci.length > 1){  
            c.daneTabeli.zakresy.wartosci.shift();
          } else {
            console.info("Nie prawidłowa ilośc parametrów ", "TabelaSpecjanla",c.daneTabeli.zakresy.wartosci, c);
          }
        } else {
          console.info("była tabela ", c.ParamDoZmiany );
        }
        
      } */


      if(c.typ == KindCount.Licz){
        if(wartosc != null){
          wartosc.Wartosc = this.Licz(c.CoZrobic, ParametryAktualne);
          // console.info(c.ParamDoZmiany + " =", wartosc.Wartosc);
        } else {
          var x = new Parametr();
          x.Nazwa = c.ParamDoZmiany;
          x.Wartosc = this.Licz(c.CoZrobic, ParametryAktualne);
          ParametryAktualne.push(x);
          // console.info("dod: "+ c.ParamDoZmiany + " =", x.Wartosc);
        }
        
      } else if(c.typ == KindCount.Tabela){
        c.daneTabeli.wartosciSzukane = new Wiersz();
        c.daneTabeli.wartosciSzukane.wartosci = [];
          c.daneTabeli.zakresy.wartosci.forEach(z => {
            c.daneTabeli.wartosciSzukane.wartosci.push(this.Licz(z, ParametryAktualne));
          });
          var byl = false;
          c.daneTabeli.wiersze.forEach(w => {
            var poprawny = true;
            for (let i = 0; i < w.wartosci.length; i++) {
              if(w.wartosci[i].includes("*")){

              } else {
                var war = w.wartosci[i].split(",");
                var pasuje = false;
                war.forEach(element => {
                  if(this.Licz(element.trim(), ParametryAktualne) == c.daneTabeli.wartosciSzukane.wartosci[i]){
                    pasuje = true;
                  }
                });
                if(!pasuje){
                    poprawny = false;
                    break;
                }
              }
              if(poprawny){
                byl = true;
                  if(wartosc != null){
                    wartosc.Wartosc = this.Licz(w.wynik, ParametryAktualne);
                    // console.info("zmienia wartosc tabeli: "+c.ParamDoZmiany + " =", wartosc.Wartosc);
                  } else {
                    var x = new Parametr();
                    x.Nazwa = c.ParamDoZmiany;
                    x.Wartosc = this.Licz(w.wynik, ParametryAktualne);
                    ParametryAktualne.push(x);
                    // console.info("dod wartosc tabeli: "+ c.ParamDoZmiany + " =", x.Wartosc);
                  }
                  break;
                }
              }
           
          });
          /*if(!byl){
            if(wartosc != null){
                    wartosc.Wartosc = "X";
                    // console.info("zmienia wartosc tabeli: "+c.ParamDoZmiany + " =", wartosc.Wartosc);
                  } else {
                    var x = new Parametr();
                    x.Nazwa = c.ParamDoZmiany;
                    x.Wartosc = "X";
                    ParametryAktualne.push(x);
                    // console.info("dod wartosc tabeli: "+ c.ParamDoZmiany + " =", x.Wartosc);
                  }
          } */
      } else if(c.typ == KindCount.TabelaSpecjanla){
        
        // console.info("Do zrobienia", "TabelaSpecjanla");
        c.daneTabeli.wartosciSzukane = new Wiersz();
        c.daneTabeli.wartosciSzukane.wartosci = [];
          c.daneTabeli.zakresy.wartosci.forEach(z => {
            c.daneTabeli.wartosciSzukane.wartosci.push(this.Licz(z, ParametryAktualne));
          });
      } else if(c.typ == KindCount.TabelaWartoscMax){
        
        // console.info("Do zrobienia", "TabelaWartoscMax");
        c.daneTabeli.wartosciSzukane = new Wiersz();
        c.daneTabeli.wartosciSzukane.wartosci = [];
          c.daneTabeli.zakresy.wartosci.forEach(z => {
            c.daneTabeli.wartosciSzukane.wartosci.push(this.Licz(z, ParametryAktualne));
          });
      } else if(c.typ == KindCount.TabelaWybór){
        
        // console.info("Do zrobienia", "TabelaWybór");
        c.daneTabeli.wartosciSzukane = new Wiersz();
        c.daneTabeli.wartosciSzukane.wartosci = [];
          c.daneTabeli.zakresy.wartosci.forEach(z => {
            c.daneTabeli.wartosciSzukane.wartosci.push(this.Licz(z, ParametryAktualne));
          });
      } else if(c.typ == KindCount.TabelaWybórTekstTekst){
        
        // console.info("Do zrobienia", "TabelaWybórTekstTekst");
        c.daneTabeli.wartosciSzukane = new Wiersz();
        c.daneTabeli.wartosciSzukane.wartosci = [];
          c.daneTabeli.zakresy.wartosci.forEach(z => {
            c.daneTabeli.wartosciSzukane.wartosci.push(this.Licz(z, ParametryAktualne));
          });
      } else if(c.typ == KindCount.TabelaZakresDoPlusWarunek || c.typ == KindCount.TabelaZakresDo){
        // console.info("ZabelaZakresDoPlusWarunek lub TabelaZakresDo", c);

        c.daneTabeli.wartosciSzukane = new Wiersz();
        c.daneTabeli.wartosciSzukane.wartosci = [];
          c.daneTabeli.zakresy.wartosci.forEach(z => {
            c.daneTabeli.wartosciSzukane.wartosci.push(this.Licz(z, ParametryAktualne));
          });
          c.daneTabeli.wiersze.forEach(w => {
            var poprawny = true;
            for (let i = 0; i < w.wartosci.length; i++) {
              if(w.wartosci[i].includes("*")){

              } else {
                var pasuje = false;
                if(i == 0){
                  var war = w.wartosci[i].split(":");
                  if(war.length > 1){
                    try {
                        if(Number.parseFloat(c.daneTabeli.wartosciSzukane.wartosci[i]) > Number.parseFloat(war[0]) && Number.parseFloat(c.daneTabeli.wartosciSzukane.wartosci[i]) < Number.parseFloat(war[1])){
                          pasuje = true;
                        }
                        // console.info("Pasuje " + war[0] +" < " + c.daneTabeli.wartosciSzukane.wartosci[i] + " < " + war[1] , c, Number.parseFloat(c.daneTabeli.wartosciSzukane.wartosci[i]), Number.parseFloat(war[0]) , Number.parseFloat(war[1]));
                    } catch (Exception){
                      // console.info("Nie pasuje " + war[0] +" < " + c.daneTabeli.wartosciSzukane.wartosci[i] + " < " + war[1] , c);
                    }
                  } else {
                     // console.info("Nie prawidłowa ilośc wartos w pierwszej kolumnie ZabelaZakresDoPlusWarunek lub TabelaZakresDo", c);
                  }
                } else {
                    var war = w.wartosci[i].split(",");
                    war.forEach(element => {
                      if(this.Licz(element.trim(), ParametryAktualne) == c.daneTabeli.wartosciSzukane.wartosci[i]){
                        pasuje = true;
                      }
                    });
                }
                  
                  if(!pasuje){
                      poprawny = false;
                      break;
                  }
              }
              if(poprawny){
                  if(wartosc != null){
                    wartosc.Wartosc = this.Licz(w.wynik, ParametryAktualne);
                    // console.info("zmienia wartosc tabeli: "+c.ParamDoZmiany + " =", wartosc.Wartosc);
                  } else {
                    var x = new Parametr();
                    x.Nazwa = c.ParamDoZmiany;
                    x.Wartosc = this.Licz(w.wynik, ParametryAktualne);
                    ParametryAktualne.push(x);
                    // console.info("dod wartosc tabeli: "+ c.ParamDoZmiany + " =", x.Wartosc);
                  }
                  break;
                }
              }
           
          });
          
      } 
      
      
  }
  public Licz(doZrobienia:string, ParametryAktualne:Parametr[]){
    ParametryAktualne.forEach(p => {
      doZrobienia = doZrobienia.replace(p.Nazwa, p.Wartosc);
    });
    if(doZrobienia.startsWith("\"")){
      return doZrobienia.replace(/"/, '');
    } else if(doZrobienia.startsWith("F_")){
      // console.info("funkcja", doZrobienia);
      var nazwa = doZrobienia.replace(/\(.*/, '').trim();
      var f = this.Functions.find(x => "F_"+x.Name == nazwa);
      if(f != null){
        this.InitWylicz2(f);
        // console.info("funk", f, this.Functions, nazwa);
        var wartosci = doZrobienia.replace(/^.*?\(/, '').replace(/\)$/, '').split(",");
        for (let i = 0; i < wartosci.length; i++) {
          f.ParametryAktualne[i].Wartosc = wartosci[i].trim();
        }
        for (let i = wartosci.length; i < f.ParametryAktualne.length; i++) {
          var dod = this.ParametryAktualne.find(x => x.Nazwa == f.ParametryAktualne[i].Nazwa);
          if(dod != null){
            f.ParametryAktualne[i].Wartosc = dod.Wartosc;
          }
        }
        var x = this.Wylicz(f.Calculations, f.ParametryAktualne);
        // console.info("funkcja war", x, f);
        return x
      } else {
         console.info("Funkcja nie istnieje", doZrobienia);
        return "X";
      }
        
    } else if(doZrobienia.startsWith("Q_")){
      if(doZrobienia.startsWith("Q_Replace(") ){
        var tmp = doZrobienia.replace(/^.*?\(/, '').replace(/\)$/, '');
        var params = tmp.split(",").map(s => s.trim());
        doZrobienia = params[0].replace(new RegExp(params[1], 'g'), params[2]);
      } else if(doZrobienia.startsWith("Q_DajWartoscTabeli(") ){
        var tmp = doZrobienia.replace(/^.*?\(/, '').replace(/\)$/, '');
        var params = tmp.split(",").map(s => s.trim());
        doZrobienia = this.ParametryPrevAktualne.find(x => x.Nazwa == "&"+params[1]).Wartosc;
        // console.info("q_rep", doZrobienia);
      } else if(doZrobienia.startsWith("Q_Min(") ){
        var tmp = doZrobienia.replace(/^.*?\(/, '').replace(/\)$/, '');
        var params = tmp.split(",").map(s => s.trim());
        try {
          if(Number.parseFloat(params[0]) > Number.parseFloat(params[1])){
            doZrobienia = params[1];
          } else {
            doZrobienia = params[2];
          }
        } catch(Exception){
          doZrobienia = params[1];
        }
        // console.info("q_min", doZrobienia);
        
      } else if(doZrobienia.startsWith("Q_Contains(") ){
        var tmp = doZrobienia.replace(/^.*?\(/, '').replace(/\)$/, '');
        var params = tmp.split(",").map(s => s.trim());
        if(params.length > 1){
          if(params[0].includes(params[1])){
            doZrobienia = "TAK";
          } else {
            doZrobienia = "NIE";
          }
        } else {
            console.info("Nieprawidłowe wykonanie funkcji", doZrobienia);
        }
      } else {
           console.info("Nieznana funkcja", doZrobienia);
          
      }
    } else {
      try {
        doZrobienia = new Function(`return ${doZrobienia}`)();
      } catch(Exception){

      }
      
    }
      return doZrobienia;
  }
  public InitWylicz(obj){
    obj.Calculations = [];
    obj.Calculations_source = [];
    obj.CalculationsData.forEach(c => {
      var calc:countClass = new countClass();
      calc.parent = obj.Nazwa;
      if(calc.parent == null){
      calc.parent = obj.Name;
      }
      c = c.trim();
      var lines_tmp = c.split("\r\n");
      var lines = [];
      lines_tmp.forEach(l => {
        l = l.trim();
        if(l != ""){
          lines.push(l);
        }
      });
      if(lines.length > 0){
        var p_tmp = lines[0].split("=");
        if(p_tmp.length > 1){
          calc.ParamDoZmiany = p_tmp[0].trim();
          calc.CoZrobic = p_tmp[1].trim();
          if(calc.CoZrobic.startsWith("Tabela")){
            calc.CoZrobic = calc.CoZrobic.replace(/ /g, "");
            if(calc.CoZrobic.startsWith("Tabela(")){
              calc.typ = KindCount.Tabela;
            } else if(calc.CoZrobic.startsWith("TabelaZakresDo(")){
              calc.typ = KindCount.TabelaZakresDo;
            } else if(calc.CoZrobic.startsWith("TabelaDajLista(")){
              calc.typ = KindCount.TabelaDajLista;
            } else if(calc.CoZrobic.startsWith("TabelaZakresDoPlusWarunek(")){
              calc.typ = KindCount.TabelaZakresDoPlusWarunek;
            } else if(calc.CoZrobic.startsWith("TabelaSpecjanla(")){
              calc.typ = KindCount.TabelaSpecjanla;
            } else if(calc.CoZrobic.startsWith("TabelaWybór(")){
              calc.typ = KindCount.TabelaWybór;
            } else if(calc.CoZrobic.startsWith("TabelaWybórTekstTekst(")){
              calc.typ = KindCount.TabelaWybórTekstTekst;
            } else if(calc.CoZrobic.startsWith("TabelaWartoscMax(")){
              calc.typ = KindCount.TabelaWartoscMax;
            } else {
               console.info("Nie wiem co to za tabela?", lines,calc.CoZrobic);
            }
            var tab_tmp = calc.CoZrobic.replace(/^.*?\(/, '').replace(/\)$/, '');
            calc.daneTabeli = new Tabela();
            calc.daneTabeli.zakresy = new Wiersz();
            calc.daneTabeli.zakresy.wartosci = tab_tmp.split(",").map(s => s.trim());
            calc.daneTabeli.wiersze = [];
            for (let index = 1; index < lines.length; index++) {
              var linia_tmp = lines[index].replace(/^\[|\]$/g, '');
              var rownanie = linia_tmp.split("=");
              var w = new Wiersz();
              if(rownanie.length > 0){
                w.wartosci = rownanie[0].split(";").map(s => s.trim());
                // console.info(w.wartosci);
                calc.daneTabeli.wiersze.push(w);
                if((calc.typ == KindCount.Tabela || calc.typ == KindCount.TabelaZakresDo || calc.typ == KindCount.TabelaZakresDoPlusWarunek) && w.wartosci.length != calc.daneTabeli.zakresy.wartosci.length){
                     console.info("Nie prawidłowa ilośc danych w tabeli?", lines);
                }
              }
              if(rownanie.length > 1){
                w.wynik = rownanie[1].trim();
              }
            }
            // console.info("tabela", calc);

          } else if(calc.CoZrobic.startsWith("SQL(")){
             console.info("Zapytanie sql", calc);
          }  else if(lines.length == 1){
            calc.typ = KindCount.Licz;
          } else {
             console.info("Nie wiem co to?", lines);
          }
          
        } else {
          console.info("Nie ma równania?", lines);
        }
      }
      obj.Calculations.push(calc);

      var calc2:countClass = new countClass();
      calc2.init(calc);
      obj.Calculations_source.push(calc2);

      
    });
        
  }
  
  public InitWylicz2(obj){
    obj.Calculations = [];
    obj.Calculations_source.forEach(calc => {
      var calc2:countClass = new countClass();
      calc2.init(calc);
      obj.Calculations.push(calc2);
    });
    console.log("wyliczona funkcja ", obj);   
  }
}
